export default function intValidator (rule, value, callback) {
    if (!/^\d+$/.test(value)){
        callback(rule.message);
    }
    callback();
}
